import BonusCollection from "../../model/bonus/BonusCollection";
import PickUpgradeCollection from "../../model/upgrade/ore/PickUpgradeCollection";
import Page from "../framework/Page";
import ParentView from "../framework/ParentView";
import MenuPanel from "../menu/MenuPanel";
import PopupViewController from "../menu/PopupViewController";
import { PageIds } from "../PageIds";
import PrimaryUpgradeTabBar from "./PrimaryUpgradeTabBar";
import MinedUpgradeAutomation from "../../model/automation/MinedUpgradeAutomation";
import PickUpgradeAutomation from "../../model/automation/PickUpgradeAutomation";
import PrestigeAutomation from "../../model/automation/PrestigeAutomation";
import PickUpgradePanel from "./PickUpgradePanel";
import GoldUpgradePanel from "./GoldUpgradePanel";
import GoldUpgradeCollection from "../../model/upgrade/gold/GoldUpgradeCollection";
import MinedUpgradeCollection from "../../model/upgrade/free/MinedUpgradeCollection";
import FreeUpgradePanel from "./free/FreeUpgradePanel";
import { Images } from "../../Images";

export default class PrimaryUpgradePanel extends ParentView {
    /**
     * @param {string} parentId
     * @param {MinedUpgradeCollection} minedUpgradeCollection
     * @param {MinedUpgradeAutomation} minedUpgradeAutomation
     * @param {PickUpgradeCollection} pickUpgradeCollection
     * @param {PickUpgradeAutomation} pickUpgradeAutomation
     * @param {GoldUpgradeCollection} goldUpgradeCollection
     * @param {PrestigeAutomation} prestigeAutomation
     * @param {BonusCollection} bonusCollection
     * @param {PopupViewController} popupViewController
     */
    constructor(parentId, 
        minedUpgradeCollection, minedUpgradeAutomation,
        pickUpgradeCollection, pickUpgradeAutomation,
        goldUpgradeCollection,
        prestigeAutomation,
        popupViewController) {
        super(parentId, PageIds.PRIMARY_UPGRADE_PANEL);

        const upgradeTabBar = new PrimaryUpgradeTabBar(this.elementId);

        this.addView(upgradeTabBar);

        const freeUpgradesPanel = new FreeUpgradePanel(this.elementId, minedUpgradeCollection, minedUpgradeAutomation);

        const pickUpgradePanel = new PickUpgradePanel(this.elementId, PageIds.PICK_UPGRADES_PANEL, 
            pickUpgradeCollection, pickUpgradeAutomation);

        const goldUpgradePanel = new GoldUpgradePanel(this.elementId, PageIds.GOLD_UPGRADES_PANEL, goldUpgradeCollection);

        const menuPanel = new MenuPanel(this.elementId, popupViewController, prestigeAutomation);

        this.addView(freeUpgradesPanel);
        this.addView(pickUpgradePanel);
        this.addView(goldUpgradePanel);
        this.addView(menuPanel);

        // Setup the tabs
        upgradeTabBar.addPanelView(freeUpgradesPanel, Images.currency.upgrades);
        upgradeTabBar.addPanelView(pickUpgradePanel, Images.currency.ore);
        upgradeTabBar.addPanelView(goldUpgradePanel, Images.currency.gold);
        upgradeTabBar.addPanelView(menuPanel, Images.pick);

        // Let the UI know that this panel is visisble and should stay that way
        this.setViewVisible(true);
        this.setCurrentlyVisible(true);
    }

    /**
     * @override
     */
    initializeView() {

        // <div id="primaryUpgradePanel" class="primary-upgrade-panel">

        const parentElement = Page.getElement(this.parentId);
        Page.createElement('div', parentElement, this.getElementId(), 'primary-upgrade-panel');

        super.initializeView();
    }

    /**
     * Returns the value that the display property should be set to in order to make
     * the element visible. 
     * 
     * By default this is 'block', but you should overwrite this if the element is 'display:flex' or something other than 'display:block'.
     * @override
     * @returns {string}
     */
    getVisibileDisplayValue() {
        return 'flex';
    }

}